<div class="container g-0 m-0">
    <div class="row row g-0 m-0">
        <div class="row g-0 m-0 d-flex align-items-center pt-4 pb-3 ps-2 mt-3">
            <div class="col-md-8">
                <h2 class="col title">
                    {{ "DEVICES_TITLE" | translate }}
                </h2>
                <h6 class="col subtitle">{{ "DEVICES_SUBTITLE" | translate }}</h6>
            </div>
            <div class="col-md-4 d-flex justify-content-end gap-3 pe-xl-5">
                @if (
                authService.isAuthorized([PermissionsEnum.Device_bulk_download])
                ) {
                <button class="col-auto add justify-content-center" (click)="download()">
                    {{ "DOWNLOAD" | translate }}
                </button>
                }
                @if (authService.isAuthorized([PermissionsEnum.Device_bulk_upload]) && isActive('devices/all-devices'))
                {
                <button class="col-auto add justify-content-center" [routerLink]="['/upload/device']">
                    {{ "BULK_IMPORT" | translate }}
                </button>
                }
                @if (authService.isAuthorized([PermissionsEnum.Device_add])) {
                <button class="col-auto add justify-content-center text-nowrap" [routerLink]="['/device-setup']">
                    {{ "DEVICES_ADDDEVICE" | translate }}
                </button>
                }
            </div>
        </div>
    </div>
    <div class="row g-0 m-0 mb-3">
        <ul>
            @if(authService.isAuthorized([PermissionsEnum.Device_view])){
            <li (click)="navigate('devices/all-devices')" [class.active]="isActive('devices/all-devices')">
                {{ "DEVICES_ALLDEVICES" | translate }}
            </li>
            }
            @if(authService.isAuthorized([PermissionsEnum.Device_view])){
            <li (click)="navigate('devices/recently-added')" [class.active]="isActive('devices/recently-added')">
                {{ "DEVICES_RECENTLYADDED" | translate }}
            </li>
            }
<!--    TODO: Unconfigured devices disabled until we figure out how to resolve the tenant -->
            @if(false && authService.isAuthorized([PermissionsEnum.Device_view])){
            <li (click)="navigate('devices/uncofigured-meters')"
                [class.active]="isActive('devices/uncofigured-meters')">
                {{ "DEVICES_UNCONFIGURED" | translate }}
            </li>
            }
        </ul>
    </div>
    <div class="row g-0 m-0">
        <router-outlet #childOutlet="outlet"></router-outlet>
    </div>
</div>
